import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { useIntl } from 'react-intl'
import LabeledText from '../../../../components/common/form-components/labeled-inputs/LabeledText'

import CenterService from '../../../../services/centers/center.service'

import './centerForm.scss'
import LabeledCalendar from '../../../../components/common/form-components/labeled-calendar/LabeledCalendar'
import SaveButton from '../../../../components/common/buttons/SaveButton'
import useInputs from '../../../../utils/hooks/useInputs'
import ComercialDataTypesService from '../../../../services/settings/centers/centerComercialDataTypes/centerComercialDataTypes.service'
import DeleteButton from '../../../../components/common/buttons/DeleteButton'
import swalAlert from '../../../../utils/helpers/swalAlert'
import { Group, Stack } from '@mantine/core'
import AppButton from '../../../../component/common/AppButton'
import { AppModalContent } from '../../../../component/layout/AppModal'
import { useTranslation } from 'react-i18next'
import AppInput from '../../../../component/form/AppInput'
import AppDateInput from '../../../../component/form/AppDateInput'

const CenterComercialDataForm = ({ centerId, rowId, close = () => {} }) => {
  const { t } = useTranslation()

  const { inputs, onChangeInputs, updateInputs } = useInputs()

  const [comercialDataTypes, setComercialDataTypes] = useState()

  useEffect(() => {
    getCenterComercialData()
    getComercialDataTypes()
  }, [])

  const getCenterComercialData = async () => {
    if (
      centerId &&
      centerId !== 'undefined' &&
      rowId &&
      rowId !== 'undefined'
    ) {
      const response = await CenterService.comercialData.getById({
        id: centerId,
        rowId,
      })
      if (response) {
        updateInputs(response.resp)
      } else {
        updateInputs({
          date: new Date(),
        })
      }
    } else {
      updateInputs({
        date: new Date(),
      })
    }
  }

  const getComercialDataTypes = async () => {
    const response = await ComercialDataTypesService.getAll({})
    if (response) {
      setComercialDataTypes(response.resp)
    }
  }

  const handleSave = async () => {
    // console.log('handleSave', rowId)
    if (centerId && centerId !== 'undefined') {
      // console.log('inputs', inputs)
      const data = {
        ...inputs,
      }
      const response =
        rowId && rowId !== 'undefined'
          ? await CenterService?.comercialData?.update({
              id: centerId,
              rowId,
              body: data,
            })
          : await CenterService?.comercialData?.create({
              id: centerId,
              body: data,
            })
      // console.log('response', response)
      if (response) {
        close()
        // updateInputs(response?.resp)
      }
    }
  }

  const handleRemove = async () => {
    const confirm = await swalAlert.warning(
      t('button.delete'),
      t('button.cancel'),
      t('button.delete'),
    )
    if (confirm?.isConfirmed) {
      const response = await CenterService?.comercialData?.remove({
        id: centerId,
        rowId,
      })
      if (response) {
        close()
      }
    }
  }

  return (
    <AppModalContent
      buttons={[
        <AppButton preset="remove" onClick={handleRemove} />,
        <AppButton preset="save" onClick={handleSave} />,
      ]}
      content={
        <Stack w="100%">
          <AppInput
            label="name"
            withAsterisk
            name="name"
            value={inputs?.name}
            onChange={onChangeInputs}
          />
          <AppDateInput
            label="date"
            withAsterisk
            name="date"
            value={inputs?.date}
            onChange={onChangeInputs}
          />
        </Stack>
      }
    />
  )
}

export default CenterComercialDataForm
